
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $7abc43fac45f5d0e$exports = {};

$7abc43fac45f5d0e$exports = (parcelRequire("daZiC")).getBundleURL('bdfE3') + "column.6c3560d4.js";


var $9c97d8e5e329d2b6$exports = {};

$9c97d8e5e329d2b6$exports = (parcelRequire("daZiC")).getBundleURL('bdfE3') + "layout.c9624adb.js";


var $2b55fb7b36fa579e$exports = {};

$2b55fb7b36fa579e$exports = (parcelRequire("daZiC")).getBundleURL('bdfE3') + "facies.5e9d6724.js";


var $6e45a5419735359b$exports = {};

$6e45a5419735359b$exports = (parcelRequire("daZiC")).getBundleURL('bdfE3') + "settings.fd67daa2.js";


var $3214660bf9afe0bb$exports = {};

$3214660bf9afe0bb$exports = (parcelRequire("daZiC")).getBundleURL('bdfE3') + "lithology.150e6c03.js";


var $f8df9b5abf232214$exports = {};

$f8df9b5abf232214$exports = (parcelRequire("daZiC")).getBundleURL('bdfE3') + "asset-path.c0893af2.js";


var $aed1ece9d183b8ab$exports = {};

$aed1ece9d183b8ab$exports = (parcelRequire("daZiC")).getBundleURL('bdfE3') + "model-editor.5c344fb1.js";




//# sourceMappingURL=context.4f0f40f1.js.map
